export interface InCartProperty {
  id: string;
  name?: string;
  checkin: string;
  checkout: string;
  image?: string;
  city: string;
  adults: number;
  children: number;
  propertyId?: number;
  marketingChannelId?: number;
  rooms: number;
  ratePlan: CartRatePlan;
  offerIndex: number;
  fencingAttributes?: string;
}

export interface CartRatePlan {
  roomName?: string;
  available: boolean;
  leadPrice: {
    currencySymbol?: string;
    formatted?: string;
    raw?: number;
  };
  totalPrice: {
    currencySymbol?: string;
    formatted?: string;
    raw?: number;
  };
  priceAfterLoyaltyPointsApplied: {
    currencySymbol?: string;
    formatted?: string;
    raw?: number;
  };
  fees: string[];
}

export interface BasicError {
  message: string;
}

export interface MaxRoomsFailureReason extends BasicError {
  groupLink: string;
}

export interface PrepareCheckoutResponse {
  checkoutUrl?: string;
  failureReason?: MaxRoomsFailureReason;
}

export enum PackageType {
  FC = 'FC', // Flight and Car
  FH = 'FH', // Flight and Hotel
  FHC = 'FHC', // Flight, Hotel and Car
  HC = 'HC', // Hotel and Car
}

export enum MitStep {
  HOTEL = 'HOTEL',
  ROOM = 'ROOM',
  DEPARTUREFLIGHT = 'DEPARTUREFLIGHT',
  RETURNFLIGHT = 'RETURNFLIGHT',
  CAR = 'CAR',
}

export enum FCStep {
  DEPARTUREFLIGHT,
  RETURNFLIGHT,
  CAR,
}

export enum FHStep {
  HOTEL,
  ROOM,
  DEPARTUREFLIGHT,
  RETURNFLIGHT,
}

export enum FHCStep {
  HOTEL,
  ROOM,
  DEPARTUREFLIGHT,
  RETURNFLIGHT,
  CAR,
}

export enum HCStep {
  HOTEL,
  ROOM,
  CAR,
}

export interface MultiItemContext {
  id: string;
  packageType: PackageType;
}

export interface ShoppingContext {
  multiItem: MultiItemContext;
}
